import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { UserStore } from '../../../store/user/user.store';
import { providerRouter } from './helper/provider-router.helper';
import { ProviderStore } from '../../../store/provider/provider.store';

export const onboardingDocumentsMatchGuard: CanMatchFn = async (route, segments) => {
  const userStore = inject(UserStore);
  const providerStore = inject(ProviderStore);
  const router = inject(Router);

  try {
    await providerStore.getAllProvidersByClinic();
    const providers = providerStore.entities();
    const isUserActive = userStore.active();

    // SUCCESS CONDITION: At least one provider needs documents (status 4)
    const hasProviderAtStep4 = providers.some(p => p.onboarding_status === 4);

    if (hasProviderAtStep4 && !isUserActive) {
      return true;
    }

    // If no one is at 4, they might all be at 5+. 
    // Redirect to the "current" global status.
    return router.createUrlTree([providerRouter(userStore.onboarding_status())]);
    
  } catch (error) {
    return router.createUrlTree(['/login']); 
  }
};